import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { usePageTitle } from "@/utils/usePageTitle";

import { MediaLibraryView } from "../Courses/components/MediaLibrary/MediaLibraryView";

/**
 * The media library as a place of its own: everything the company has generated or
 * uploaded, across every scenario.
 *
 * Deliberately offers no "use this here" — there is no *here* on a page that belongs to no
 * scenario. Assigning happens where the context exists: the scenario's own form for its
 * thumbnail, large image and trailer, and the phase editor's picker for phase content. This
 * page is for looking at what exists, seeing where it is used, and clearing out what is not.
 */
export const MediaPage: FunctionComponent = () => {
	const { t } = useTranslation();

	usePageTitle(t("courses.mediaLibrary.pageTitle"));

	return (
		<div className="space-y-5 p-6 pb-10">
			<MediaLibraryView />
		</div>
	);
};
